
import { motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import { Link } from "react-router-dom"
import appStore from "../assets/images/app-store.svg"
import googlePlay from "../assets/images/google-play.svg"
import { fadeIn, fadeUp, staggerContainer } from "../lib/motion"

export function DownloadSection() {
  const { translation: t } = useLanguage()

  return (
    <motion.section
      variants={fadeIn}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.div className="container mx-auto md:px-4" variants={staggerContainer(0.1, 0.05)}>

        <div className="max-w-3xl mx-auto text-center">
          <motion.h2 className="text-2xl md:text-4xl lg:text-[2.5rem] font-bold text-primary mb-6 md:mb-11" variants={fadeUp}>
            {t.downloadTitle}
          </motion.h2>

          <motion.div className="flex justify-center gap-6 mb-6 md:mb-11" variants={staggerContainer(0.08, 0.04)}>
            {/* App Store */}
            <motion.div variants={fadeUp}>
            <Link
              to="https://apps.apple.com/eg/app/nowpay/id1453539431"
              target="_blank"
              rel="noopener noreferrer"
              className="hover-lift"
            >
              <img src={appStore} alt="appStore" className="hover-scale" />
            </Link>
            </motion.div>
            {/* Google Play */}
            <motion.div variants={fadeUp}>
            <Link
              to="https://play.google.com/store/apps/details?id=com.nowpay.nowpay"
              target="_blank"
              rel="noopener noreferrer"
              className="hover-lift"
            >
              <img src={googlePlay} alt="googlePlay" className="hover-scale" />
            </Link>
            </motion.div>
          </motion.div>

          <p className="text-primary text-base md:text-lg lg:text-[1.375rem] font-normal !leading-[130%] lg:!leading-[1.875rem]">{t.downloadDesc}</p>
          <p className="text-primary text-base md:text-lg lg:text-[1.375rem] font-bold !leading-[130%] lg:!leading-[1.875rem]">{t.downloadCta}</p>
        </div>
      </motion.div>
    </motion.section>
  )
}
